import styles from './Settings.module.css'
import {useCallback, useEffect, useRef, useState} from "react";
import UserStore from "../../store/user-store";
import {observer} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import Lottie from "react-lottie";
import checkmark from "../Lottie/checkmark.json"
import {createPortal} from "react-dom";
import {AnimatePresence, motion} from "framer-motion";
import {useHaptic} from "../../Hooks/useHaptic";

export const Settings = observer(() => {
    const menuRef = useRef(null);
    const langSelectorRef = useRef(null)
    const [isVisible, setIsVisible] = useState(true);
    const [isLangSelect, setLangSelect] = useState(false);
    const [isLangVisible, setLangVisible] = useState(false)
    const TG_WEB_APP = window.Telegram.WebApp
    const [land, setLang] = useState()
    const {t} = useTranslation();
    const {hapticFeedBack} = useHaptic('select');

    const useClickAway = (ref, handler) => {
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (ref.current && !ref.current.contains(event.target)) {
                    // Предотвращаем дальнейшее распространение клика
                    // event.preventDefault();
                    // event.stopPropagation();
                    handler(event);
                }
            };

            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('pointerdown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
                document.removeEventListener('pointerdown', handleClickOutside);
            };
        }, [ref, handler]);
    };

    const handleClickOutMenu = useCallback((event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            hapticFeedBack(); // Haptic feedback при закрытии кликом вне окна
            setIsVisible(false);
            setTimeout(() => UserStore.setSettingWindow(false), 300) // Увеличиваем время до 800ms
        }
    }, [hapticFeedBack]);


    useEffect(() => {
        document.addEventListener("pointerdown", handleClickOutMenu)

        return () => document.removeEventListener("pointerdown", handleClickOutMenu)
    }, []);

    useClickAway(langSelectorRef, () => {
        setLangVisible(false);
        setTimeout(() => setLangSelect(false), 300) // Время для закрытия языкового селектора
    });

    const close = () => {
        hapticFeedBack(); // Haptic feedback при закрытии
        setIsVisible(false);
        setTimeout(() => UserStore.setSettingWindow(false), 300) // Увеличиваем время до 800ms чтобы анимация завершилась
    }

    const languages = [
        {
            code: "en",
            name: "English",
            flag: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
                <g clipPath="url(#clip0_1733_13868)">
                    <rect width="32" height="24" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 0V24H32V0H0Z" fill="#2E42A5"/>
                    <mask id="mask0_1733_13868" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="32" height="24">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 0V24H32V0H0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_1733_13868)">
                        <path
                            d="M-3.56299 22.2851L3.4787 25.2632L32.1599 3.23756L35.8743 -1.18792L28.3442 -2.18327L16.6458 7.3082L7.2298 13.7032L-3.56299 22.2851Z"
                            fill="white"/>
                        <path d="M-2.59912 24.3719L0.988295 26.1001L34.5403 -1.59884H29.5032L-2.59912 24.3719Z"
                              fill="#F50100"/>
                        <path
                            d="M35.563 22.2851L28.5213 25.2632L-0.159939 3.23756L-3.87427 -1.18792L3.6558 -2.18327L15.3542 7.3082L24.7702 13.7032L35.563 22.2851Z"
                            fill="white"/>
                        <path
                            d="M35.3228 23.7825L31.7353 25.5107L17.4485 13.6514L13.2128 12.3264L-4.23163 -1.17283H0.805515L18.2402 12.006L22.8712 13.5948L35.3228 23.7825Z"
                            fill="#F50100"/>
                        <mask id="path-7-inside-1_1733_13868" fill="white">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M19.7781 -2H12.2225V8H-1.97217V16H12.2225V26H19.7781V16H34.0278V8H19.7781V-2Z"/>
                        </mask>
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M19.7781 -2H12.2225V8H-1.97217V16H12.2225V26H19.7781V16H34.0278V8H19.7781V-2Z"
                              fill="#F50100"/>
                        <path
                            d="M12.2225 -2V-4H10.2225V-2H12.2225ZM19.7781 -2H21.7781V-4H19.7781V-2ZM12.2225 8V10H14.2225V8H12.2225ZM-1.97217 8V6H-3.97217V8H-1.97217ZM-1.97217 16H-3.97217V18H-1.97217V16ZM12.2225 16H14.2225V14H12.2225V16ZM12.2225 26H10.2225V28H12.2225V26ZM19.7781 26V28H21.7781V26H19.7781ZM19.7781 16V14H17.7781V16H19.7781ZM34.0278 16V18H36.0278V16H34.0278ZM34.0278 8H36.0278V6H34.0278V8ZM19.7781 8H17.7781V10H19.7781V8ZM12.2225 0H19.7781V-4H12.2225V0ZM14.2225 8V-2H10.2225V8H14.2225ZM-1.97217 10H12.2225V6H-1.97217V10ZM0.027832 16V8H-3.97217V16H0.027832ZM12.2225 14H-1.97217V18H12.2225V14ZM14.2225 26V16H10.2225V26H14.2225ZM19.7781 24H12.2225V28H19.7781V24ZM17.7781 16V26H21.7781V16H17.7781ZM34.0278 14H19.7781V18H34.0278V14ZM32.0278 8V16H36.0278V8H32.0278ZM19.7781 10H34.0278V6H19.7781V10ZM17.7781 -2V8H21.7781V-2H17.7781Z"
                            fill="white" mask="url(#path-7-inside-1_1733_13868)"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_1733_13868">
                        <rect width="32" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        },
        {
            code: "ru",
            name: "Русский",
            flag: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
                <g clipPath="url(#clip0_1715_2475)">
                    <g clipPath="url(#clip1_1715_2475)">
                        <rect width="32" height="24" fill="white"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 0V24H32V0H0Z" fill="#3D58DB"/>
                        <mask id="mask0_1715_2475" maskUnits="userSpaceOnUse" x="0" y="0"
                              width="32" height="24">
                            <path fillRule="evenodd" clipRule="evenodd" d="M0 0V24H32V0H0Z" fill="white"/>
                        </mask>
                        <g mask="url(#mask0_1715_2475)">
                            <path fillRule="evenodd" clipRule="evenodd" d="M0 0V8H32V0H0Z" fill="#F7FCFF"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M0 16V24H32V16H0Z" fill="#C51918"/>
                        </g>
                    </g>
                    <rect width="32" height="24" fill="url(#paint0_linear_1715_2475)"/>
                </g>
                <defs>
                    <linearGradient id="paint0_linear_1715_2475" x1="32" y1="1.19273e-06" x2="1.6098e-06" y2="24"
                                    gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" stopOpacity="0.3"/>
                        <stop offset="0.262741" stopOpacity="0.27"/>
                        <stop offset="0.369956" stopColor="white" stopOpacity="0.26"/>
                        <stop offset="0.487001" stopOpacity="0.55"/>
                        <stop offset="0.594445" stopOpacity="0.24"/>
                        <stop offset="0.736408" stopColor="white" stopOpacity="0.3"/>
                        <stop offset="0.901459" stopColor="#272727" stopOpacity="0.22"/>
                        <stop offset="1" stopOpacity="0.2"/>
                    </linearGradient>
                    <clipPath id="clip0_1715_2475">
                        <rect width="32" height="24" rx="4" fill="white"/>
                    </clipPath>
                    <clipPath id="clip1_1715_2475">
                        <rect width="32" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        },
    ]

    useEffect(() => {
        setLang(languages.filter(el => el.code === UserStore.langCode)[0])
    }, [UserStore.langCode]);

    // Haptic feedback при открытии окна
    useEffect(() => {
        if (UserStore.settingWindow) {
            hapticFeedBack();
        }
    }, [UserStore.settingWindow]);


    const SupportBlock = () => {
        const [isCodeCopy, setIsCodeCopy] = useState(false)

        async function copyToClipboard(text) {
            try {
                await navigator.clipboard.writeText(text);
            } catch (err) {
            }
        }

        return (
            <div className={styles.settings_item}>
                <h1>{t("settings.support_block.h1")}</h1>
                <div className={styles.support_code_wrapper}>

                    <button disabled={isCodeCopy} className={styles.support_code} onClick={async () => {
                        hapticFeedBack(); // Haptic feedback при копировании
                        setIsCodeCopy(true)
                        await copyToClipboard(`${UserStore.telegramId}_${process.env.REACT_APP_NAME}`)
                    }}>
                        {isCodeCopy ?
                            <Lottie
                                options={{
                                    loop: false,
                                    autoplay: true,
                                    animationData: checkmark
                                }}
                                eventListeners={
                                    [
                                        {
                                            eventName: "complete",
                                            callback: () => setIsCodeCopy(false),
                                        }
                                    ]
                                }
                            />
                            :
                            (
                                <>
                                    <h1>{t('settings.support_block.p_code')}</h1>
                                    <div style={{display: "flex", gap: 6}}>
                                        <p>{UserStore.telegramId}</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                             viewBox="0 0 20 20"
                                             fill="none">
                                            <g clipPath="url(#clip0_1969_40955)">
                                                <path
                                                    d="M17.8661 4.89918H13.8339C13.5213 4.89918 13.4105 4.77822 13.4105 4.46571L13.4004 0.3629C13.6726 0.40322 13.9246 0.58467 14.227 0.897176L17.3217 4.07257C17.6343 4.38507 17.8157 4.62701 17.8661 4.89918Z"
                                                    fill="url(#paint0_linear_1969_40955)"/>
                                                <path
                                                    d="M5.49715 2.83266H6.93868C8.23909 2.83266 9.18666 3.22581 10.0536 4.11289L14.1262 8.28629C14.9024 9.08265 15.2754 10.1008 15.2653 11.3609V15.9879H15.3863C17.0798 15.9879 17.9266 15.131 17.9266 13.4173V5.97781H13.6524C12.8056 5.97781 12.3318 5.49394 12.3318 4.65726V0H8.0274C6.33384 0 5.49715 0.897177 5.49715 2.49998V2.83266Z"
                                                    fill="url(#paint1_linear_1969_40955)"/>
                                                <path
                                                    d="M8.51126 10.1814H13.9649C13.8742 9.8387 13.6826 9.51612 13.2794 9.10282L9.21691 4.9395C8.81369 4.53628 8.48101 4.27419 8.13828 4.18345V9.80845C8.13828 10.0504 8.26932 10.1814 8.51126 10.1814ZM4.19675 20H11.5556C13.2492 20 14.0959 19.1431 14.0959 17.4294V11.3609H8.53143C7.46288 11.3609 6.96892 10.8569 6.96892 9.7883V4.0121H4.19675C2.50321 4.0121 1.6665 4.86895 1.6665 6.58265V17.4294C1.6665 19.1532 2.50321 20 4.19675 20Z"
                                                    fill="url(#paint2_linear_1969_40955)"/>
                                            </g>
                                            <defs>
                                                <linearGradient id="paint0_linear_1969_40955" x1="11.6708" y1="19.9926"
                                                                x2="3.90827" y2="0.412811"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#F44E17"/>
                                                    <stop offset="1" stop-color="#FFAC00"/>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_1969_40955" x1="11.6708" y1="19.9926"
                                                                x2="3.90827" y2="0.412811"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#F44E17"/>
                                                    <stop offset="1" stop-color="#FFAC00"/>
                                                </linearGradient>
                                                <linearGradient id="paint2_linear_1969_40955" x1="11.6708" y1="19.9926"
                                                                x2="3.90827" y2="0.412811"
                                                                gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#F44E17"/>
                                                    <stop offset="1" stop-color="#FFAC00"/>
                                                </linearGradient>
                                                <clipPath id="clip0_1969_40955">
                                                    <rect width="20" height="20" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </>
                            )
                        }
                    </button>

                    <p>{t("settings.support_block.p1")}</p>
                </div>
                <button className={styles.support_btn}
                        onClick={() => {
                            hapticFeedBack(); // Haptic feedback при открытии поддержки
                            TG_WEB_APP.openTelegramLink(process.env.REACT_APP_SUPPORT_URL)
                        }}>
                    <div style={{display: 'flex', gap: 8}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                             fill="none">
                            <g clipPath="url(#clip0_1972_10835)">
                                <path
                                    d="M20.066 12.1004C19.8071 11.7092 19.4529 11.4042 19.0458 11.2008C19.185 9.37367 18.6265 7.8465 17.776 7.7726L17.7449 7.76992C17.7048 6.22521 17.2033 4.69113 16.2685 3.3779C14.7628 1.26273 12.3393 0 9.78546 0C7.23158 0 4.80801 1.26273 3.30224 3.37797C2.36688 4.69227 1.86539 6.22724 1.82563 7.77302L1.79483 7.7756C0.930031 7.85084 0.363265 9.42617 0.528691 11.2938C0.694463 13.1621 1.53003 14.6153 2.39438 14.5401H2.39473L5.21637 14.2947C5.45426 14.274 5.6741 14.1605 5.82755 13.9792C5.9036 13.8894 5.96104 13.7856 5.99658 13.6738C6.03212 13.562 6.04507 13.4443 6.03468 13.3276L5.59285 8.34114C5.54913 7.85018 5.1123 7.4869 4.61672 7.53029L3.87033 7.59535C3.93762 6.52601 4.30184 5.47446 4.96646 4.54078C6.10801 2.93718 7.86432 2.01767 9.78543 2.01767C11.7064 2.01767 13.4628 2.93724 14.6044 4.54078C15.2686 5.4735 15.6322 6.52405 15.7002 7.59205L14.9541 7.52733C14.4586 7.48395 14.0217 7.84716 13.978 8.33818L13.5361 13.3246C13.5258 13.4414 13.5388 13.5591 13.5743 13.6709C13.6099 13.7827 13.6673 13.8864 13.7433 13.9762C13.8193 14.066 13.9124 14.1401 14.0173 14.1943C14.1222 14.2484 14.2368 14.2815 14.3546 14.2918L17.1762 14.5372H17.1765C17.8124 14.5924 18.4302 13.8173 18.7799 12.662C18.8332 12.7174 18.8873 12.7723 18.9306 12.838C19.0481 13.0147 19.1191 13.2177 19.1374 13.4285C19.1556 13.6393 19.1205 13.8513 19.0351 14.0452L18.1391 16.0875C18.006 16.3909 17.7864 16.6492 17.5072 16.8306C17.228 17.012 16.9013 17.1086 16.5674 17.1085H15.3615C15.2631 16.7945 14.9787 16.562 14.6294 16.562H12.3947C11.9652 16.562 11.617 16.9071 11.617 17.3327V18.2293C11.617 18.6549 11.9652 19 12.3947 19H14.6294C14.9787 19 15.2631 18.7675 15.3615 18.4535H16.5674C17.791 18.4535 18.8968 17.735 19.384 16.6233L20.2803 14.581C20.6361 13.7684 20.5562 12.8409 20.066 12.1004Z"
                                    fill="#0A0C0D"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1972_10835">
                                    <rect width="20" height="20" fill="white" transform="translate(0.5)"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <p>{t("settings.support_block.p2")}</p>
                    </div>
                </button>
            </div>
        )
    }
    const LanguageBlock = () => {
        return (
            <div className={styles.settings_item}>
                <h1>{t('settings.setting_block.h1')}</h1>
                <div className={styles.languages_wrapper}>

                    <div className={styles.languages}>
                        <p>{t('settings.setting_block.p')}</p>

                        <div className={styles.selector} onClick={(e) => {
                            e.stopPropagation();
                            if (!isLangSelect) {
                                hapticFeedBack(); // Haptic feedback при открытии языкового селектора
                                setLangSelect(true);
                                setLangVisible(true);
                            }
                        }}>
                            <div className={styles.selector_active_lang}>
                                {land?.flag}
                                {land?.name}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    const LanguageBlockPortal = () => {
        return (
            <>
                <motion.div
                    key="bg"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 900,
                        overflow: "hidden"
                    }}
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.2, ease: "easeInOut"}}
                />
                <motion.div
                    key="lang-block"
                    style={{
                        zIndex: 1000,
                        bottom: 0,
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        // backgroundColor: 'rgba(0, 0, 0, 0.5)', // задний фон
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    initial={{opacity: 0, y: 50, filter: 'blur(10px)', scale: 0.8}}
                    animate={{opacity: 1, y: 0, filter: 'blur(0)', scale: 1}}
                    exit={{opacity: 0, y: 50, filter: 'blur(10px)', scale: 0.8}}
                    transition={{duration: 0.2, ease: 'easeInOut'}}
                >
                    <div ref={langSelectorRef} style={{zIndex: 101}} className={styles.selector_wrapper}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingBottom: '16px',
                                zIndex: 100,
                                position: 'relative',
                            }}
                        >
                            <h1 style={{
                                fontSize: '24px',
                                fontWeight: '600',
                                lineHeight: '28px',
                                letterSpacing: '-0.24px'
                            }}>
                                {t('settings.lang_selector')}
                            </h1>
                        </div>
                        <div className={styles.select_lang}>
                            {languages.map((el, index) => (
                                <button
                                    key={index}
                                    style={el.code === UserStore.langCode ? {background: 'rgba(255, 255, 255, 0.10)'} : {}}
                                    className={styles.select_lang_item}
                                    onClick={() => {
                                        hapticFeedBack(); // Haptic feedback при выборе языка
                                        UserStore.setLangCode(el.code);
                                        setLangVisible(false);
                                        setTimeout(() => setLangSelect(false), 300);
                                    }}
                                >
                                    {el.flag} {el.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </motion.div>

            </>
        );
    };

    const TransactionBlock = () => {
        return (
            <div className={styles.settings_item}>
                <h1>{UserStore.langCode === 'ru' ? 'Транзакции' : "Transactions"}</h1>
                <p style={{opacity: 0.3}}>{UserStore.langCode === 'ru' ?"Транзакции отсутствуют" : "No transactions"}</p>
            </div>
        )
    }

    const ToggleSwitch = observer(({isOn, handleToggle}) => {
        return (
            <div className={styles.toggle_switch}>
                <input
                    checked={UserStore.visual_effects.anim_bg}
                    onChange={() => {
                        hapticFeedBack(); // Haptic feedback при переключении toggle
                        UserStore.setVisualEffectsAnimBg()
                    }}
                    className={styles.toggle_switch_checkbox}
                    id={`toggle-switch`}
                    type="checkbox"
                />
                <label
                    className={styles.toggle_switch_label}
                    htmlFor={`toggle-switch`}
                >
                    <span className={styles.toggle_switch_button}/>
                </label>
            </div>
        );
    });

    const VisualSettingsBlock = () => {
        return (
            <div className={styles.settings_item}>
                <h1>{t('Визуальные эффекты')}</h1>
                <div className={styles.visual_block_items}>
                    <div className={styles.visual_block_item}>
                        <p>Анмированный фон</p>
                        <ToggleSwitch/>
                    </div>

                </div>
            </div>
        )
    }

    return (
        createPortal(
            <div ref={menuRef} className={`${styles.container} ${!isVisible ? styles.hide : ""}`}>
                <div className={styles.content}>

                    <motion.div
                        drag="y"
                        dragElastic={0}            // отключаем "эластичность"
                        dragMomentum={false}       // отключаем инерцию
                        dragConstraints={{top: 0, bottom: 0}}  // ограничиваем движение
                        onDragEnd={(event, info) => {
                            // Восстановление стилей
                            if (menuRef.current) {
                                menuRef.current.style.transition = 'transform 0.8s cubic-bezier(0.4, 0.0, 0.2, 1), opacity 0.8s cubic-bezier(0.4, 0.0, 0.2, 1)';
                            }
                            
                            if (info.offset.y > 50) {
                                hapticFeedBack(); // Haptic feedback при drag-закрытии
                                close();
                            } else {
                                // Возвращаем в исходное положение
                                if (menuRef.current) {
                                    menuRef.current.style.opacity = '1';
                                    menuRef.current.style.transform = 'translateY(0) scale(1)';
                                }
                            }
                        }}
                        onDragStart={() => {
                            // Сброс стилей при начале drag
                            if (menuRef.current) {
                                menuRef.current.style.transition = 'none';
                            }
                        }}
                        onDrag={(event, info) => {
                            // Плавная анимация при drag
                            if (info.offset.y > 0) {
                                const progress = Math.min(info.offset.y / 100, 1);
                                const opacity = 1 - progress * 0.3;
                                const scale = 1 - progress * 0.05;
                                if (menuRef.current) {
                                    menuRef.current.style.opacity = opacity;
                                    menuRef.current.style.transform = `translateY(${info.offset.y * 0.5}px) scale(${scale})`;
                                }
                            }
                        }}
                        style={{
                            touchAction: "none",
                            position: "relative",


                        }}>
                    <span style={{
                        position: 'absolute',
                        width: 30,
                        height: 5,
                        left: "50%",
                        transform: "translateX(-50%)",
                        borderRadius: "12px",
                        background: "grey"
                    }}/>
                    <div className={styles.heading}>
                        <button onClick={close}>&larr; {t('settings.heading.btn')}</button>
                    </div>
                    </motion.div>
                    <div className={styles.settings_item_wrapper}>
                        <LanguageBlock/>
                        <TransactionBlock/>
                        <SupportBlock/>
                        {/*<VisualSettingsBlock/>*/}
                        <footer style={{
                            width: "100%",
                            position: "relative",
                            bottom: "0",
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center"
                        }}>
                            <a href="https://deguard.io" rel="noopener" target="_blank" style={{opacity: 0.6}}>Powered
                                by
                                DeGuard.io</a>
                        </footer>
                    </div>


                </div>
                <AnimatePresence>
                    {isLangSelect && isLangVisible && <LanguageBlockPortal/>}
                </AnimatePresence>

            </div>, document.body)
    )
})
